import {FC, createContext, useContext, useState} from 'react'
import {WithChildren} from '../../../../general/helpers'

const initPromotionsDashboardContextPropsState = {
  filtersType: undefined,
  saveFiltersType: () => {},
  selectedFilterType: undefined,
}
const PromotionsDashboardContext = createContext<any>(initPromotionsDashboardContextPropsState)

const usePromotionsDash = () => {
  return useContext(PromotionsDashboardContext)
}

const PromotionsDashboardProvider: FC<WithChildren> = ({children}) => {
  const [filtersType, setFiltersType] = useState()
  const [selectedFilterType, setSelectedFilterType] = useState()
  const [querylistings, setQuerylistings] = useState()
  const [labels, setLabels] = useState()
  const saveSelectedFilterType = (value) => {
    setSelectedFilterType(value)
  }
  const saveFiltersType = (filters_types) => {
    setFiltersType(filters_types)
  }
  const saveQueryListings = (listings) => {
    setQuerylistings(listings)
  }
  const saveLabels = (label) => {
    setLabels(label)
  }

  return (
    <>
      <PromotionsDashboardContext.Provider
        value={{
          filtersType,
          saveFiltersType,
          selectedFilterType,
          saveSelectedFilterType,
          querylistings,
          saveQueryListings,
          labels,
          saveLabels,
        }}
      >
        <div className='position-relative'>{children}</div>
      </PromotionsDashboardContext.Provider>
    </>
  )
}
export {usePromotionsDash, PromotionsDashboardProvider}
